import {CLEARANCE_SASH_IMAGE_NAME, SALE_SASH_IMAGE_NAME, SASH_IMAGE_EXTENSION} from "../../config/constants"

const getSash = (sashType: string | null, language: string) => {
    switch (sashType?.toLowerCase()) {
        case "clearance":
            return `${CLEARANCE_SASH_IMAGE_NAME}-${language.toUpperCase()}${SASH_IMAGE_EXTENSION}`
        case "sale":
            return `${SALE_SASH_IMAGE_NAME}_${language.toUpperCase()}${SASH_IMAGE_EXTENSION}`
        default:
            return sashType
    }
}

export default getSash
